// packages/web-ui/src/AppShell/drawer-tabs/UtilityDrawerContent.tsx
//
// W2-S9 — polymorphic body that lazy-renders the active tab.
//
// Switching tabs unmounts the previous body so per-tab state (scroll
// position, expanded rows) is not retained — the source-of-truth lives
// in the slice (sse `eventLog`, kb selectedEntityId, etc.). This is
// intentional per UX §7.4 + the "buffer in slice, not component" rule
// from Pitfall #3 of the W2-S9 story.

import type { JSX } from 'react';
import type { ActiveDestination } from '../../state/navigation.js';
import type { DrawerTab } from '../../state/utilityDrawer.js';
import { ActivityTab } from './ActivityTab.js';
import { DetailTab } from './DetailTab.js';
import { DebugTab } from './DebugTab.js';

export interface UtilityDrawerContentProps {
  activeTab: DrawerTab;
  destination: ActiveDestination;
}

export function UtilityDrawerContent({
  activeTab,
  destination,
}: UtilityDrawerContentProps): JSX.Element {
  switch (activeTab) {
    case 'activity':
      return <ActivityTab />;
    case 'detail':
      return <DetailTab destination={destination} />;
    case 'debug':
      return <DebugTab />;
    default: {
      const _exhaustive: never = activeTab;
      void _exhaustive;
      return <ActivityTab />;
    }
  }
}
